import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { Providers } from './app/Providers';
import { router } from './app/router';
import MainSiteApp from './features/signup/MainSiteApp';
import { detectPlatform } from './features/signup/platform';
import { PlatformContext } from './features/signup/platform-context';

const root = createRoot(document.getElementById('root')!);

// Domaine principal : inscription des cliniques. Adresse d'une clinique : l'application.
void detectPlatform().then((platform) => {
  root.render(
    <StrictMode>
      {platform?.space === 'main' ? (
        <MainSiteApp platform={platform} />
      ) : (
        <PlatformContext.Provider value={platform}>
          <Providers>
            <RouterProvider router={router} />
          </Providers>
        </PlatformContext.Provider>
      )}
    </StrictMode>,
  );
});
